

const Empower25 = () => {
    window.location.href = "https://empower2025-55e39.web.app/";
    return (
        <div> please wait ... </div>
    )
}

export default Empower25;

